export default {"src":"/_next/static/media/sdk_3.a53acfa6.svg","height":115,"width":107,"blurWidth":0,"blurHeight":0};